import { render } from "./BalanceView.vue?vue&type=template&id=184a8a86"
import script from "./BalanceView.vue?vue&type=script&lang=js"
export * from "./BalanceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__